import type { StatusType } from '@/types/Models/Assignment'
import {
  CANCELLED,
  COMPLETE,
  LABELS_CREATING,
  LABELS_RELEASED,
  OPEN,
  OPTIMISING,
  PENDING,
  REPORT_ACCEPTED,
  REPORT_DENIED,
  REPORT_RELEASED,
  VALIDATING,
  VALIDATION_COMPLETE,
} from '@/const/AssignmentStatuses'

type StatusColorMap = {
  [key in StatusType]: string
}

export const StatusColor: StatusColorMap = {
  [OPEN]: '#3498db',
  [PENDING]: '#f1c40f',
  [COMPLETE]: '#2ecc71',
  [CANCELLED]: '#c0392b',
  [VALIDATING]: '#bdc3c7',
  [VALIDATION_COMPLETE]: '#2ecc71',
  [OPTIMISING]: '#9b59b6',
  [REPORT_RELEASED]: '#1abc9c',
  [REPORT_ACCEPTED]: '#27ae60',
  [REPORT_DENIED]: '#e74c3c',
  [LABELS_CREATING]: '#95a5a6',
  [LABELS_RELEASED]: '#16a085',
}
